import React from 'react';
import DOMPurify from 'dompurify';
import { useState, useEffect } from 'react';

const SmallProductCard = ({
	index,
	product,
	selectedSubscriptionDetails,
	subscriptionProducts,
	productPrice,
	productDiscountedPrice,
	adjustSubscriptionQuantities,
	formatMoney,
}) => {
	const [quantity, setQuantity] = useState(0);
	const [previousQuantity, setPreviousQuantity] = useState(0);

	useEffect(() => {
		if (quantity != previousQuantity) {
			adjustSubscriptionQuantities(product, quantity);
		}
	}, [quantity]);

	useEffect(() => {
		if (selectedSubscriptionDetails) {
			setQuantity(selectedSubscriptionDetails.products[product].custom_bottles);
			setPreviousQuantity(selectedSubscriptionDetails.products[product].custom_bottles);
		} else {
			setQuantity(0);
			setPreviousQuantity(0);
		}
	}, [selectedSubscriptionDetails]);

	return (
		<div key={index} className="columns" data-handle={product}>
			<div className="product-cart-item-small">
				<div className="product-cart-item-image">
					<div
						className={`product-cart-item-image__wrapper product-cart-item-image__wrapper--${
							selectedSubscriptionDetails
								? Math.min([...Array(selectedSubscriptionDetails?.products[product]?.custom_bottles)].length, 8)
								: 1
						}-products`}
					>
						{selectedSubscriptionDetails ? (
							[...Array(selectedSubscriptionDetails.products[product].custom_bottles)]
								.map((_, index) => {
									return (
										<img
											alt={subscriptionProducts[product].fetchData.title}
											src={subscriptionProducts[product].fetchData.images[0]}
											data-sizes="auto"
											height="900"
											width="700"
											className="image--vertical lazyautosizes lazyload"
											sizes="176px"
											srcSet={subscriptionProducts[product].fetchData.images[0]}
											key={index}
										/>
									);
								})
								.filter((_, index) => index < 8)
						) : (
							<img
								alt={subscriptionProducts[product].fetchData.title}
								src={subscriptionProducts[product].fetchData.images[0]}
								data-sizes="auto"
								height="900"
								width="700"
								className="image--vertical lazyautosizes lazyload"
								sizes="176px"
								srcSet={subscriptionProducts[product].fetchData.images[0]}
							/>
						)}
					</div>
					{selectedSubscriptionDetails && (
						<div className="quantity small-qty">
							<button
								className="minus"
								type="button"
								onClick={() => {
									setPreviousQuantity(quantity);
									setQuantity(quantity - 1 > 0 ? quantity - 1 : 1);

									// send event to Crazy Egg
									(window['CE_API'] || (window['CE_API'] = [])).push(function () {
										window['CE2']?.converted('208e26b2-bcc9-4cca-8a91-288d8f83b232');
									});
								}}
							>
								<svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M3.49692e-08 1.39998L0 0.599976L8 0.599976V1.39998L3.49692e-08 1.39998Z"
										fill="var(--color-accent)"
									></path>
								</svg>
							</button>
							<input
								type="number"
								id={`quantity-${subscriptionProducts[product].fetchData.title.split(' ').join('')}`}
								value={quantity}
								min="1"
								className="qty"
								readOnly
							/>
							<button
								className="plus"
								type="button"
								onClick={() => {
									setPreviousQuantity(quantity);
									setQuantity(quantity + 1);

									// send event to Crazy Egg
									(window['CE_API'] || (window['CE_API'] = [])).push(function () {
										window['CE2']?.converted('85849f95-09b3-4371-ac9e-3b6baaabce24');
									});
								}}
							>
								<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3.6 0H4.4V8H3.6V0Z" fill="var(--color-accent)"></path>
									<path d="M3.49692e-08 4.4L0 3.6L8 3.6V4.4L3.49692e-08 4.4Z" fill="var(--color-accent)"></path>
								</svg>
							</button>
						</div>
					)}
				</div>
				<div className="product-cart-item-details">
					<div
						className="cart-product-description rte"
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(
								subscriptionProducts[product].product_instructions.replace(
									subscriptionProducts[product].fetchData.title,
									`<a
                                        className="cart-product-link"
                                        title=${subscriptionProducts[product].fetchData.title}
                                        href=${subscriptionProducts[product].fetchData.url}
                                        style="text-decoration: none;"
                                    ><strong>${subscriptionProducts[product].fetchData.title}</strong>
                                    </a>`,
								),
							),
						}}
					></div>

					<div className="flex-container flex-dir-row align-right align-middle">
						<p className="product-cart-item-quantity flex-container flex-dir-column no-margin">
							{selectedSubscriptionDetails ? (
								subscriptionProducts[product].price_display === 'price_per_item' ? (
									<>
										<span className="bottles-prices-full">
											<span className="bottles-prices-full__original-price">
												{formatMoney?.(productPrice / 100) ?? `${(productPrice / 100).toFixed(2)} ${window['store']?.currency ?? ''}`}
											</span>
										</span>
										<span className="bottles-prices-discounted">
											<span className="bottles-prices-discounted__original-label">
												Your price/1 {subscriptionProducts[product].label}:
											</span>
											<span className="bottles-prices-discounted__original-price">
												{formatMoney?.(productDiscountedPrice) ?? `${productDiscountedPrice.toFixed(2)} ${window['store']?.currency ?? ''}`}
											</span>
										</span>
										<span className="bottles-prices-savings">
											<span className="bottles-prices-savings__original-label">
												Your savings/1 {subscriptionProducts[product].label}:
											</span>
											<span className="bottles-prices-savings__original-price">
												{formatMoney?.(productPrice / 100 - productDiscountedPrice) ?? `${(productPrice / 100 - productDiscountedPrice).toFixed(2)} ${window['store']?.currency ?? ''}`}
											</span>
										</span>
									</>
								) : (
									<>
										<span className="bottles-prices-full">
											<span className="bottles-prices-full__original-price">
												{formatMoney?.((productPrice / 100) * quantity) ?? `${((productPrice / 100) * quantity).toFixed(2)} ${window['store']?.currency ?? ''}`}
											</span>
										</span>
										<span className="bottles-prices-discounted">
											<span className="bottles-prices-discounted__original-label">
												Your price/1 {subscriptionProducts[product].label}:
											</span>
											<span className="bottles-prices-discounted__original-price">
												{formatMoney?.(productDiscountedPrice * quantity) ?? `${(productDiscountedPrice * quantity).toFixed(2)} ${window['store']?.currency ?? ''}`}
											</span>
										</span>
										<span className="bottles-prices-savings">
											<span className="bottles-prices-savings__original-label">
												Your savings/1 {subscriptionProducts[product].label}:
											</span>
											<span className="bottles-prices-savings__original-price">
												{formatMoney?.((productPrice / 100 - productDiscountedPrice) * quantity) ?? `${((productPrice / 100 - productDiscountedPrice) * quantity).toFixed(2)} ${window['store']?.currency ?? ''}`}
											</span>
										</span>
									</>
								)
							) : (
								''
							)}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SmallProductCard;
